import router from '@/modules/contacts/router'

export default {
  router,
}
